<template lang="pug">
  .rules
    Frame(mod="small-pad")
      transition-group.rules__items(name="rules__items", tag="ul", :style="'height: ' + itemsHeight + 'px;'")
        li.rules__item(
          v-for="item in items",
          ref="item",
          :class="{ 'rules__item_active' : item.id === currentStep, 'rules__item_wide' : item.id === 1 }",
          :key="item.id"
        )
          .rules__title-cont(v-if="item.title")
            .rules__title(v-if="item.id !== 5")
              span(v-html="item.title")
              template(v-if="name") ,
              template(v-else) !
            .rules__title-light(v-if="item.id === 5")
              span(v-html="item.title")
              template(v-if="name")
            p.rules__title-name(v-if="item.id === 1 && name") {{ name }}!
          .rules__icon(v-if="item.icon", :class="'rules__icon_' + item.icon")
          Controls(v-if="item.controls")
          p.rules__text(v-html="item.text", :class="{ 'rules__text_hidden' : item.textXs }")
          p.rules__text.rules__text_xs(v-if="item.textXs", v-html="item.textXs")
      .rules__steps(ref="steps")
        ul.rules__steps-items
          li.rules__steps-item(v-for="item in items.length", @click="stepClick(item)")
        .rules__steps-player(ref="player", :style="'left: ' + playerLeft + 'px;'")
      Buttons(type="rules", @next="next")
</template>

<script>
import Frame from '@/components/UI/Frame';
import Controls from '@/components/UI/Controls';
import Buttons from '@/components/UI/Buttons';
import consts from '@/js/consts';
import { mapGetters } from 'vuex';

let deltaWidth = 0;
let partWidth;

export default {
  name: 'Rules',
  components: { Frame, Controls, Buttons },
  computed: {
    ...mapGetters(['name']),
  },
  mounted() {
    this.getWindowWidth();
    this.getItemsHeight();
    this.setDefaultValues();

    window.addEventListener('resize', () => {
      this.getWindowWidth();
      this.getItemsHeight();
      this.setDefaultValues();
    });
  },
  methods: {
    stepClick(item) {
      this.currentStep = item;
      this.getPlayerLeft();
    },
    next() {
      if (this.currentStep <= this.items.length - 1) {
        this.currentStep += 1;
        this.getPlayerLeft();
      } else {
        this.$router.push({ name: 'GoodLuck' });
      }
    },
    getPlayerLeft() {
      deltaWidth = this.playerWidth / 2;

      if (this.defaultPlayerLeft === 0) {
        if (this.currentStep === this.items.length) {
          deltaWidth = this.playerWidth - 5; // 5 - выезжание за край шкалы на 5px
        } else if (this.currentStep === 1) {
          deltaWidth = 0;
        }
      }

      this.playerLeft = ((this.currentStep - 1) * partWidth) - deltaWidth;
    },
    getItemsHeight() {
      const items = this.$refs.item;
      const heightValues = [];

      items.forEach((item) => {
        heightValues.push(item.offsetHeight);
      });

      this.itemsHeight = Math.max(...heightValues);
    },
    getWindowWidth() {
      consts.windowWidth = window.innerWidth;
    },
    setDefaultValues() {
      if (this.$refs.steps) {
        this.playerWidth = this.$refs.player.offsetWidth;
        this.defaultPlayerLeft = consts.windowWidth <= consts.MAX_WINDOW_WIDTH_XS ? 0 : -this.playerWidth / 2;
        this.playerLeft = this.defaultPlayerLeft;
        this.currentStep = 1;

        const stepsWidth = this.$refs.steps.offsetWidth;
        partWidth = stepsWidth / (this.items.length - 1);
      }
    },
  },
  data() {
    return {
      itemsHeight: 0,
      playerLeft: 0,
      playerWidth: 0,
      currentStep: 1,
      items: [
        {
          id: 1,
          title: 'Привет',
          text: '<b>Вас ждет Новогодняя Бобровая гонка.<br>Вот что вам нужно знать, чтобы победить в&nbsp;игре.<br>Цель игры&nbsp;&mdash; набрать как можно больше Бобровой&nbsp;струи<br>и порадовать Бобра Мороза</b>',
        },
        {
          id: 2,
          icon: 'lives',
          text: 'У вас есть бесконечное<br>количество попыток. Будьте осторожны:<br>в каждой попытке у вас только три Бобра',
        },
        {
          id: 3,
          icon: 'power',
          text: 'Следите за уровнем заряда своего Бобромобиля<br>и собирайте бутылки бобровой струи,<br>чтобы не выйти из строя раньше времени',
        },
        {
          id: 4,
          icon: 'enemy',
          text: 'Уклоняйтесь от плохого креатива и опасных<br>проектов, чтобы не потерять своих Бобров',
        },
        {
          id: 5,
          title: 'Чтобы управлять Бобромобилем,<br>используйте кнопки:',
          text: 'Чтобы поставить игру на паузу, нажмите пробел',
          textXs: 'Чтобы поставить игру на паузу, нажмите кнопку&nbsp;паузы',
          controls: 1,
        },
      ],
    };
  },
};
</script>

<style lang="scss">
  $step-size: 14px;
  $step-size-xs: 10px;
  $icon-height: 118px;
  $icon-height-xs: 80px;
  $steps-width-max: 420px;

  .rules {
    &__step {
      &s {
        position: relative;
        @include vertical-align;
        width: 100%;
        max-width: $steps-width-max;
        &-item {
          z-index: z('default') + 1;
          position: relative;
          width: $step-size;
          height: $step-size;
          border-radius: $step-size;
          background: $clr-middleBlue;
          cursor: pointer;
          @media (max-width: $max-width-xs) {
            width: $step-size-xs;
            height: $step-size-xs;
            border-radius: $step-size-xs;
          }
          &:last-child {
            margin: 0;
          }
          &:before {
            @include pseudo;
            top: -20px;
            bottom: -20px;
            left: -20px;
            right: -20px;
          }
          &s {
            @include nl;
            position: relative;
            @include vertical-align;
            width: 100%;
            justify-content: space-between;
            &:after {
              @include pseudo;
              left: 0;
              right: 0;
              height: 2px;
              background: $clr-middleBlue;
            }
          }
        }
        &-player {
          z-index: z('default') + 2;
          position: absolute;
          @include retina-sprite($steps-player-group);
          @include player-trans;
          @media (max-width: $max-width-xs) {
            @include retina-sprite($steps-player-xs-group);
          }
        }
      }
    }
    &__title-light {
      @include typo-h1($weight: normal);
      color: $clr-hoverMain;
      &-cont {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        height: $icon-height;
        @media (max-width: $max-width-xs) {
          height: $icon-height-xs;
        }
      }
      &-name {
        @include typo-h1($weight: normal);
        color: $clr-darkMain;
      }
    }
    &__title {
      @include typo-h1;
      color: $clr-hoverMain;
      &-cont {
        display: flex;
        justify-content: flex-end;
        flex-direction: column;
        height: $icon-height;
        @media (max-width: $max-width-xs) {
          height: $icon-height-xs;
        }
      }
      &-name {
        @include typo-h1;
        color: $clr-darkMain;
      }
    }
    &__text {
      @include typo-text;
      color: $clr-blue;
      margin: 25px 0 0;
      @media (max-width: $max-width-xs) {
        @include typo-p(normal);
        margin: 19px auto 0;
        max-width: 500px;
      }
      &_hidden {
        @media (-moz-touch-enabled: 1),
          (pointer: coarse) {
          display: none;
        }
      }
      &_xs {
        display: none;
        @media (-moz-touch-enabled: 1),
          (pointer: coarse) {
          display: block;
        }
      }
    }
    &__text-bold {
      @include typo-text($w: bold);
      color: $clr-blue;
      margin: 25px 0 0;
      @media (max-width: $max-width-xs) {
        @include typo-p(bold);
        margin: 19px auto 0;
        max-width: 500px;
      }
      &_hidden {
        @media (-moz-touch-enabled: 1),
        (pointer: coarse) {
          display: none;
        }
      }
      &_xs {
        display: none;
        @media (-moz-touch-enabled: 1),
        (pointer: coarse) {
          display: block;
        }
      }
    }
    &__icon {
      @include vertical-align;
      justify-content: center;
      &:before {
        @include pseudo($pos: relative);
        @include retina-sprite($icon-bg-group);
        @media (max-width: $max-width-xs) {
          @include retina-sprite($icon-bg-xs-group);
        }
      }
      &:after {
        @include pseudo;
      }
      @each $name, $sprite, $spriteXs in
      (lives, $icon-heart-group, $icon-heart-xs-group),
      (power, $icon-power-group, $icon-power-xs-group),
      (enemy, $icon-enemy-group, $icon-enemy-xs-group) {
        &_#{$name} {
          &:after {
            @include retina-sprite($sprite);
            @media (max-width: $max-width-xs) {
              @include retina-sprite($spriteXs);
            }
          }
        }
      }
    }
    // transition-group animation
    &__item {
      position: absolute;
      width: 100%;
      left: 0;
      right: 0;
      text-align: center;
      opacity: 0;
      transition: opacity .4s ease;
      transition-delay: 0;
      &_active {
        position: relative;
        opacity: 1;
        transition-delay: .3s;
      }
      &_wide {
        @media (min-width: 1024px) {
          width: 682px !important;
        }
      }
      &s {
        @include nl;
        @include vertical-align;
        position: relative;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0 0 52px;
        width: 100%;
        @media (max-width: $max-width-xs) {
          margin: 0 0 45px;
        }
        &-leave {
        &-active {
            opacity: 0;
            position: absolute;
          }
        }
        &-enter,
        &-leave-to {
          opacity: 0;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rules.vue